<script>
  import Icono from "./Icono.svelte";
  import Tooltip from "./Tooltip.svelte";

  export let marcaje;

  let tooltip = false;
</script>

<style>
    .ico {
        display: inline-flex;
        border-radius: var(--radio-global);
        align-items: center;
        justify-content: center;
        padding: 5px;
        position: relative;
    }

    .marcaje--actividad {
        --color: var(--verde);
    }

    .marcaje--actividad .ico {
        background: var(--verde);
    }

    .marcaje--ausencia {
        --color: var(--naranja);
    }

    .marcaje--ausencia .ico {
        background: var(--naranja);
    }
</style>

<span class={`marcaje marcaje--${marcaje.motivo.tipo.toLowerCase()}`}>
<span class="ico" on:mouseover={() => tooltip = true}
      on:focus={() => tooltip = true}
      on:mouseleave={() => tooltip = false} on:blur={() => tooltip = false}>
    <Icono svg={marcaje.motivo.icono} tamano="mediano" externo/>
    {#if marcaje.sede && tooltip}
        <Tooltip>
            {marcaje.sede}
        </Tooltip>
    {/if}
</span>
    <slot />
</span>